import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  ProjectOutlined,
  TeamOutlined,
  ScheduleOutlined,
  RiseOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <ProjectOutlined />,
  1: <TeamOutlined />,
  2: <ScheduleOutlined />,
  3: <BarChartOutlined />,
};

const BenefitsSection = () => {
  const { t } = useTranslation("pm");

  const items = useMemo(() => {
    const raw = t("benefits.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  return (
    <section className="dev-pm-section dev-pm-benefits-section">
      <div className="dev-pm-section-inner">
        <h2 className="dev-section-h2 dev-pm-section-h2">
          <span className="dev-pm-section-h2-icon dev-pm-section-h2-icon--amber" aria-hidden>
            <RiseOutlined />
          </span>
          <span>{t("benefits.title")}</span>
        </h2>

        <div className="dev-pm-benefits-grid">
          {items.slice(0, 5).map((item, idx) => (
            <div key={idx} className="dev-pm-benefit-card">
              <div className="dev-pm-benefit-left">
                <span className="dev-pm-benefit-number">{String(idx + 1).padStart(2, "0")}</span>
                <span className="dev-pm-benefit-icon">{iconByIndex[idx] ?? null}</span>
              </div>
              <div className="dev-pm-benefit-body">
                <div className="dev-pm-benefit-title">{item.title}</div>
                <div className="dev-pm-benefit-desc">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
